import {useMemo} from 'react';
import {ILink} from 'coreStore/data/page/types';
import {useLocation} from 'coreHooks';
import {absoluteUrl, rebuildPathWithParams} from 'coreUtils/url';

import {FIRST_PAGE} from 'brandConstants';

export default (pageToLoad: number, lastPageNumber: number): ILink[] => {
	const location = useLocation();

	return useMemo(() => {
		const currentURL = `${location.pathname}${location.search}`;
		const links: ILink[] = [];

		if (pageToLoad < lastPageNumber) {
			links.push({
				rel: 'next',
				href: absoluteUrl(rebuildPathWithParams(currentURL, {page: pageToLoad + 1})),
			});
		}

		if (pageToLoad > FIRST_PAGE) {
			links.push({
				rel: 'prev',
				href: absoluteUrl(rebuildPathWithParams(currentURL, {page: pageToLoad - 1})),
			});
		}

		return links;
	}, [pageToLoad, lastPageNumber]);
};
